// removed by extract-text-webpack-plugin
module.exports = {"normal":"normal__N2Cif","scroll":"scroll__1eO3e","scrollable":"scrollable__3X1BP","arrows":"arrows__LNxkt","arrowsVisible":"arrowsVisible__2Ifdj arrows__LNxkt","icon":"icon__1CyMc","animatedIcon":"animatedIcon__ZZoUB"};


//////////////////
// WEBPACK FOOTER
// ./components/HScroll/index.scss
// module id = 33gD
// module chunks = 0